import { usePostPcrProtocolApi, usePutPcrProtocolApi } from 'api/pcr_protocol'
import { FileField, InputField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { PcrProtocol, PcrProtocolForm } from 'entities/pcr_protocol'

const FormView = (form: Form<PcrProtocolForm>, apiError: ApiError) => {
    return (
        <>
            <InputField apiError={apiError} form={form} attr={'probeCount'} label="Number of probe" required />
            <InputField apiError={apiError} form={form} attr={'sampleCount'} label="Number of sample" required />
            <FileField apiError={apiError} form={form} attr={'file'} label="Protocol log file" />
            <InputField apiError={apiError} form={form} attr={'note'} label="Note" as="textarea" />
        </>
    )
}

type NewPcrProtocolFormProps = {
    onComplete?: () => void
}

export const NewPcrProtocolForm = (props: NewPcrProtocolFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostPcrProtocolApi()
    const form = useForm<PcrProtocolForm>({})
    const [show, setShow] = useState<boolean>(false)

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                setShow(false)
                props.onComplete()
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
            >
                新規登録
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>PcrProtocolの登録</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>{FormView(form, api.apiError)}</>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleUpdate}>
                        登録
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

type EditPcrProtocolFormProps = {
    pcrProtocol: PcrProtocol
    show: boolean
    onClose: () => void
    onComplete?: () => void
}

export const EditPcrProtocolForm = (props: EditPcrProtocolFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutPcrProtocolApi()
    const form = useForm<PcrProtocolForm>(props.pcrProtocol)

    useEffectSkipFirst(() => {
        form.set(props.pcrProtocol)
    }, [props.pcrProtocol])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>PcrProtocolの編集</Modal.Title>
            </Modal.Header>
            <Modal.Body>{form.object.id && <>{FormView(form, api.apiError)}</>}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
